import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=8d548e72"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"
import style0 from "./TextButton.vue?vue&type=style&index=0&id=8d548e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports